import api from '../../../api/client';
import { Button, Card, Tabs } from "antd";
import React from "react";
import SalesInvoices from "../../extra/SamplePage0014";
import UnifiedSalesDashboard from "../../extra/SamplePage0014i";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FaPlus } from "react-icons/fa";

const Sales = () => {
  return (
    <>
      <Card
        size="small"
        title="Sales Dashboard"
        extra={
          <Link to="/sales/create">
            <Button size="small">
              <FaPlus /> New Sale
            </Button>
          </Link>
        }
      >
        <Tabs
          items={[
            {
              key: "headers",
              label: "Invoice List",
              children: <SalesInvoices />,
            },
            {
              key: "items",
              label: "Item List",
              children: <UnifiedSalesDashboard />,
            },
          ]}
        />
      </Card>
    </>
  );
};

export default Sales;
